import React from "react";

function Star({ marked, starId }) {
  return (
    <span
      star-id={starId}
      style={{ color: "#707070", fontSize: 28 }}
      role="button"
    >
      {marked ? "\u2605" : "\u2606"}
    </span>
  );
}

function StarRating({ rating: receivedRating, rating, setRating, hover }) {
  // const [rating, setRating] = React.useState(
  //   typeof receivedRating === "number" ? receivedRating : 0
  // )
  const [selection, setSelection] = React.useState(0);
  const hoverOver = (event) => {
    let val = 0;
    if (event && event.target && event.target.getAttribute("star-id"))
      val = event.target.getAttribute("star-id");
    setSelection(val);
  };
  return (
    <div
      onMouseOut={() => !hover && hoverOver(null)}
      onClick={
        !hover &&
        ((event) => {
          const num = Number(event.target.getAttribute("star-id"));
          setRating(num || rating);
        })
      }
      onMouseOver={!hover && hoverOver}
    >
      {Array.from({ length: 5 }, (v, i) => (
        <Star
          starId={i + 1}
          key={`star_${i + 1} `}
          marked={selection ? selection >= i + 1 : rating >= i + 1}
        />
      ))}
    </div>
  );
}

export default StarRating;
// EXAMPLES
// <StarRating rating={2} />
